import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "admin-section" }
const _hoisted_2 = {
  href: "https://memories.gallery/file-types/",
  target: "_blank"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  href: "https://memories.gallery/config/#preview-storage",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!
  const _component_NcTextField = _resolveComponent("NcTextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$options.title), 1),
    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'You can configure the enabled Nextcloud preview providers below.')) + " " + _toDisplayString(_ctx.t('memories', 'If you are using Imaginary for preview generation, you can ignore this section.')) + " " + _toDisplayString(_ctx.t('memories', 'To enable RAW support, install the Camera RAW Previews app.')) + " ", 1),
    _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.t('memories', 'Documentation.')), 1),
    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
    (_ctx.status)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.status.imagick)
            ? (_openBlock(), _createBlock(_component_NcNoteCard, {
                key: 0,
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'PHP-Imagick is available [{version}].', { version: _ctx.status.imagick })), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_NcNoteCard, {
                key: 1,
                type: "error"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'PHP-Imagick is not available.')) + " " + _toDisplayString(_ctx.t('memories', 'Image editing will not work correctly.')) + " " + _toDisplayString(_ctx.t('memories', 'Thumbnail generation may not work for some formats (HEIC, TIFF).')), 1)
                ]),
                _: 1
              })),
          _createVNode(_component_NcNoteCard, {
            type: _ctx.binaryStatusType(_ctx.status.ffmpeg_preview)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.binaryStatus('ffmpeg preview', _ctx.status.ffmpeg_preview)) + " " + _toDisplayString(_ctx.binaryStatusOk(_ctx.status.ffmpeg_preview)
            ? _ctx.t('memories', 'Thumbnails for videos will be generated with this binary.')
            : _ctx.t('memories', 'Thumbnail generation may not work for videos.')), 1)
            ]),
            _: 1
          }, 8, ["type"]),
          (_ctx.hasProvider('OC\\Preview\\Imaginary'))
            ? (_openBlock(), _createBlock(_component_NcNoteCard, {
                key: 2,
                type: "warning"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t(
            'memories',
            'Imaginary is enabled for preview generation. This will override other preview providers. We currently recommend against using Imaginary due to multiple bugs in handling of HEIC and GIF files.',
          )), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.knownPreviewProviders, (provider, klass) => {
      return (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
        type: "switch",
        key: klass,
        "model-value": _ctx.hasProvider(klass),
        "onUpdate:modelValue": ($event: any) => (_ctx.updateProvider(klass, $event))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(provider.name), 1)
        ]),
        _: 2
      }, 1032, ["model-value", "onUpdate:modelValue"]))
    }), 128)),
    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'The following MIME types are configured for preview generation.')) + " ", 1),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
    (_ctx.status)
      ? (_openBlock(), _createElementBlock("code", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.status.mimes, (mime) => {
            return (_openBlock(), _createElementBlock("span", { key: mime }, [
              _createTextVNode(_toDisplayString(mime), 1),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Max preview size (trade-off between quality and storage requirements).')) + " ", 1),
    _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.t('memories', 'Documentation.')), 1),
    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewSizes, (size) => {
      return (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
        class: "preview-box",
        key: size,
        "model-value": String(_ctx.config['preview_max_x']),
        value: String(size),
        name: "previewsize_radio",
        type: "radio",
        "onUpdate:modelValue": ($event: any) => (_ctx.updatePreviewSize(size))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(size) + "px ", 1)
        ]),
        _: 2
      }, 1032, ["model-value", "value", "onUpdate:modelValue"]))
    }), 128)),
    _createVNode(_component_NcTextField, {
      type: "number",
      placeholder: "1024",
      label: _ctx.t('memories', 'Max memory for preview generation (MB)'),
      "label-visible": true,
      "model-value": String(_ctx.config['preview_max_memory']),
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update('preview_max_memory', Number($event.target.value))))
    }, null, 8, ["label", "model-value"]),
    _createVNode(_component_NcTextField, {
      type: "number",
      placeholder: "50",
      label: _ctx.t('memories', 'Max size of file to generate previews for (MB)'),
      "label-visible": true,
      "model-value": String(_ctx.config['preview_max_filesize_image']),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('preview_max_filesize_image', Number($event.target.value))))
    }, null, 8, ["label", "model-value"])
  ]))
}